import { render, staticRenderFns } from "./BuyMeCreditsPopup.vue?vue&type=template&id=5d6ed531&scoped=true&"
import script from "./BuyMeCreditsPopup.vue?vue&type=script&lang=js&"
export * from "./BuyMeCreditsPopup.vue?vue&type=script&lang=js&"
import style0 from "./BuyMeCreditsPopup.vue?vue&type=style&index=0&id=5d6ed531&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6ed531",
  null
  
)

export default component.exports